<div class="card">
  <div class="flex justify-between items-center mb-3">
    <h3 class="font-semibold text-base">Comments</h3>
  </div>
  <div class="mb-3">
    <textarea class="text-box w-full" rows="3" [(ngModel)]="newCommentText" placeholder="Add a comment..." [ngClass]="{'p-invalid': warn}"></textarea>
    @if (warn) {
      <p class="text-danger-base text-sm mt-1">Please enter a comment.</p>
    }
    <div class="flex justify-end mt-2">
      <button class="btn-primary btn-small" type="button" [disabled]="saving" (click)="submit()">
        <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-plus'"></i>
        <span class="ml-1 text-sm">{{saving ? 'Saving...' : 'Add Comment'}}</span>
      </button>
    </div>
    @if (errorMessage && errorMessage.length>0) {
      <p class="text-danger-base text-sm mt-1">{{errorMessage}}</p>
    }
  </div>
  @if (loading) {
    <p class="text-grey-600 text-sm">Loading comments...</p>
  }
  @if (!loading) {
    <div class="flex flex-col gap-3">
      @for (c of pagedComments; track c) {
        <div class="comment">
          <p class="font-semibold">{{c.UserDisplayName || 'User'}}</p>
          <p class="text-sm text-grey-800">{{c.Comment}}</p>
          <p class="text-xs text-grey-600">{{c.DateCreated | date:'dd MMM yyyy, HH:mm'}}</p>
        </div>
      }
      @if (comments.length === 0) {
        <p class="text-grey-500 text-sm">No comments yet.</p>
      }
    </div>
  }
  @if (comments.length > pageSize) {
    <div class="paginator-wrapper">
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="comments.length"
        [rowsPerPageOptions]="[5,10,20]"
        [pageLinkSize]="3"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  }
</div>
